import { useChromecastContext } from "~/providers";

export const useIsChromecastBarVisible = () => {
  const { isChromecastBarVisible } = useChromecastContext();
  return isChromecastBarVisible;
};
